const debounce = require('debounce');

/*------------------------------------*\
    SITE NAV
\*------------------------------------*/
class SiteNav {
    constructor(passedElement) {
        let self = this;

        self.nav = passedElement;
        self.toggles = document.querySelectorAll('.js-nav-toggle');
        self.hamburger = document.querySelector('.js-nav-toggle--hamburger');
        self.app = document.querySelector('.js-app');
        self.body = document.querySelector('body');
        self.navOpen = false;
    }

    init() {
        let self = this;

        self.toggles.forEach(function (item) {
            item.addEventListener('click', evt => {
                evt.preventDefault();

                if (self.navOpen) {
                    self.closeNav();
                } else {
                    self.openNav();
                }
            });
        });

        self.setHeight();
    }

    setHeight() {
        // Set the height of the off-canvas nav
        // Inspired by https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
        function setHeight() {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        }

        // On page load
        setHeight();

        // On window resize
        window.onresize = debounce(setHeight, 50);
    }

    openNav() {
        let self = this;

        self.hamburger.classList.add('is-active');
        self.app.classList.add('is-active');
        self.nav.classList.add('is-active');
        self.body.classList.add('is-no-scroll');
        self.navOpen = true;
    }

    closeNav() {
        let self = this;

        self.hamburger.classList.remove('is-active');
        self.app.classList.remove('is-active');
        self.nav.classList.remove('is-active');
        self.body.classList.remove('is-no-scroll');
        self.navOpen = false;
    }
}

export default SiteNav;
